import { render, staticRenderFns } from "./CommentsModal.vue?vue&type=template&id=403bee08&"
import script from "./CommentsModal.vue?vue&type=script&lang=js&"
export * from "./CommentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports